import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

function getOrgTableColumns() {
  return [
    {
      title: '学校',
      slot: 'schoolName',
      minWidth: tableColumnsWidth.type6,
      fixed: 'left'
    },
    {
      title: '学期',
      key: 'yearCodeName',
      minWidth: tableColumnsWidth.type4,
      fixed: 'left'
    },
    {
      title: '机构提供方',
      slot: 'orgName',
      minWidth: tableColumnsWidth.type6,
      fixed: 'left'
    },
    {
      title: '机构上传',
      slot: 'orgFileId',
      width: 100
    },
    {
      title: '创建时间',
      key: 'createTime',
      width: 180
    },
    {
      title: '更新时间',
      key: 'operateTime',
      width: 180
    },
    slot('操作', 'action', 210, {
      fixed: 'right',
      align: 'center'
    })
  ]
}

export function getTableColumns(portOrg) {
  return portOrg == 3
    ? getOrgTableColumns()
    : [
        key(null, null, tableColumnsWidth.type1, {
          type: 'selection',
          fixed: 'left'
        }),
        {
          title: '学校',
          slot: 'schoolName',
          minWidth: tableColumnsWidth.type6,
          fixed: 'left'
        },
        {
          title: '学期',
          key: 'yearCodeName',
          minWidth: tableColumnsWidth.type4,
          fixed: 'left'
        },
        {
          title: '机构提供方',
          slot: 'orgName',
          minWidth: tableColumnsWidth.type6,
          fixed: 'left'
        },
        {
          title: '机构上传',
          slot: 'orgFileId',
          width: 100
        },
        {
          title: '平台上传',
          slot: 'platFileId',
          width: 100
        },
        {
          title: '学校上传',
          slot: 'schoolFileId',
          width: 100
        },
        {
          title: '创建时间',
          key: 'createTime',
          width: 180
        },
        {
          title: '更新时间',
          key: 'operateTime',
          width: 180
        },
        {
          title: '是否需要手签',
          slot: 'isSign',
          align: 'center',
          width: 130
        },
        {
          title: '协议模板状态',
          slot: 'templateSts',
          width: 130,
          align: 'center'
        },
        {
          title: '配置状态',
          slot: 'configSts',
          width: 120,
          align: 'center'
        },
        {
          title: '已签约人数',
          key: 'signServiceNum',
          align: 'center',
          width: 120
        },

        slot('操作', 'action', 210, {
          fixed: 'right',
          align: 'center'
        })
      ]
}
export const variableList = [
  {
    name: '学校信息',
    list: [
      {
        name: '学校名称',
        variable: '#schoolName#'
      },
      {
        name: '学校法人',
        variable: '#schoolManger#'
      },
      {
        name: '学校地址',
        variable: '#schoolAddress#'
      },
      {
        name: '学校签章',
        variable: '#schoolStamp#'
      }
    ]
  },
  {
    name: '平台信息',
    list: [
      {
        name: '平台名称',
        variable: '#platName#'
      },
      {
        name: '平台法人',
        variable: '#platManager#'
      },
      {
        name: '平台地址',
        variable: '#platAddress#'
      },
      {
        name: '平台签章',
        variable: '#platStamp#'
      }
    ]
  },
  {
    name: '机构平台信息',
    list: [
      {
        name: '机构名称',
        variable: '#orgName#'
      },
      {
        name: '机构法人',
        variable: '#orgManager#'
      },
      {
        name: '机构地址',
        variable: '#orgAddress#'
      },
      {
        name: '机构签章',
        variable: '#orgStamp#'
      }
    ]
  },
  {
    name: '学生相关信息',
    list: [
      {
        name: '家长真实姓名',
        variable: '#parentTureName#'
      },
      {
        name: '家长身份证号码',
        variable: '#parentIdCard#'
      },
      {
        name: '家长手写签名',
        variable: '#parentWriting#'
      },
      {
        name: '学生姓名',
        variable: '#studentName#'
      },
      {
        name: '学生年级',
        variable: '#stuGrade#'
      },
      {
        name: '学生班级',
        variable: '#stuClass#'
      }
    ]
  },
  {
    name: '订单信息',
    list: [
      {
        name: '订单编号',
        variable: '#payNumber#'
      },
      {
        name: '支付金额（小写）',
        variable: '#paymentAmount#'
      },
      {
        name: '支付金额（大写）',
        variable: '#capitalPaymentAmount#'
      },
      {
        name: '支付方式',
        variable: '#payWay#'
      },
      {
        name: '支付时间',
        variable: '#chargeTime#'
      }
    ]
  },
  {
    name: '商品信息',
    list: [
      {
        name: '课程商品名称',
        variable: '#courseName#'
      },
      {
        name: '课程商品名称&原价',
        variable: '#courseName&price#'
      }
    ]
  }
]
